import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getNewsAndGuidesDetailsPageData } from './api';
import type { NewsAndGuidesDetailsPageDataErrorCode } from './types';

export const {
	Context: NewsAndGuidesDetailsPageDataContext,
	Provider: NewsAndGuidesDetailsPageDataContextProvider,
	useContext: useNewsAndGuidesDetailsPageData,
	useAsyncData: useNewsAndGuidesDetailsPageDataFromApi,
	prefetchAsyncData: prefetchNewsAndGuidesDetailsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'NewsAndGuidesDetailsPageDataContext',
	dataProperty: 'pageData',
	getData: getNewsAndGuidesDetailsPageData,
	hookDeps: ({ countryCode, locale, slug }) => [countryCode, locale, slug],
	getUniqueId: ({ countryCode, locale, slug }) => [countryCode, locale, slug].join('|'),
	errorHandler: pageDataErrorHandler<NewsAndGuidesDetailsPageDataErrorCode>(),
});
